import {
  Container,
  IconButton,
  Tooltip
} from '@material-ui/core';

import Snackbar from '@material-ui/core/Snackbar';
import { makeStyles } from '@material-ui/core/styles';
import DeleteSweepIcon from '@material-ui/icons/DeleteSweep';
import EditIcon from '@material-ui/icons/Edit';
import ErrorIcon from '@material-ui/icons/Error';
import SendIcon from '@material-ui/icons/Send';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';
import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { mapperToMaintenanceCollection } from '../../app/mappers/maintenance/maintenance-collection.mapper';
import { createMaintenanceCollectionDraft } from '../../app/services/maintenance/collection/create-collection.api';
import { deleteAllMaintenanceCollections, deleteMaintenanceCollection } from '../../app/services/maintenance/collection/delete-collection.api';
import { getDraftMaintenanceCollectionByUser } from '../../app/services/maintenance/collection/get-collection.api';
import { processMaintenanceCollection } from '../../app/services/maintenance/collection/process-collection.api';
import { updateMaintenanceCollection } from '../../app/services/maintenance/collection/update-collection.api';
import DialogSearch from '../../common/components/DialogSearch';
import EnhancedTable, { HeadCell } from '../../common/components/EnhancedTable';
import { handleCheckPrevValue } from '../../common/functions/checkPrevValue';
import CollectionPointDialog from './CollectionPointDialog';
import CollectionPointDrawer from './CollectionPointDrawer';
import CollectionPointHeader from './CollectionPointHeader';
import { customtheme } from '../../app/theme/theme';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: customtheme.gray[200],
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
  },
  tableSection: {
    padding: theme.spacing(4),
    flex: 1,
    display: 'flex',
  },
  tableSectionContainer: {
    padding: 0, 
    flex: 1,
    display: 'flex', 
    flexDirection: 'column',
    maxWidth: '100%',
  },
  appbar: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    background: customtheme.white,
    color: customtheme.black,
    padding: theme.spacing(2),
    margin: 1,
  },  
  scrollableTabs: {
    overflowX: 'auto',
  }, 
}));

interface BodyCell {
  id: string;
  codpro: number;
  despro: string;
  codccu: number;
  desccu: string;
  codder: string;
  desder: string;
  coddep: string;
  desdep: string;
  qtdeme: number;
  dateme: string;
  datprv: string;
}
interface DialogSearchData {
  id: string;
  title: string;
  key: string;
  keySub: string;
  isPrevSearch?: boolean;
  prevSearch?: any;
  prevDataSearch: any;
}

const ColletionPoint = () => {
  const classes = useStyles();

  const windowHeight = window.innerHeight;
  const headerHeight = 500; // Altura do cabeçalho em pixels
  const footerHeight = 48; // Altura do rodapé em pixels
  const itemHeight = 80; // Altura média de cada item em pixels
  const availableHeight = windowHeight - headerHeight - footerHeight;
  const itemsPerPage = Math.floor((availableHeight) / itemHeight)

  const [selectedData, setSelectedData] = useState<any>([]);
  const [orderBy, setOrderBy] = useState<string>('nomrep');
  const [selected, setSelected] = useState<string[]>([]);
  const [page, setPage] = useState(0);
  const [count, setCount] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(itemsPerPage > 5 ? itemsPerPage : 5);
  const [isDrawerOpen, setIsDrawerOpen] = useState({open: false, btnTitle: 'Salvar', btnType: 'save'});
  const [isDialogSearchOpen, setIsDialogSearchOpen] = useState(false);
  const [isDialogFeedbackOpen, setIsDialogFeedbackOpen] = useState({open:false, message: '', title: '', btnType: ''});
  const [isSnackbar, setIsSnackbar] = useState({open:false, message: 'info', title: ''});
  const [isLoading, setIsLoading] = useState(false);
  const [dialogDataSearch, setDialogDataSearch] = useState<DialogSearchData | null>(null);
  const [checkPrevCompanyValue, setCheckPrevCompanyValue] = useState({
    exists: false,
    value: ''
  })
  const [checkPrevEquipamentValue, setCheckPrevEquipamentValue] = useState({
    exists: false,
    value: ''
  })
  
  const fieldsInit = mapperToMaintenanceCollection({})

  const [fields, setFields] = useState<any[]>(fieldsInit)
  const headCells: HeadCell[] = [
    { id: 'codemp', numeric: true, disablePadding: false, label: 'Código Empresa' },
    { id: 'nomemp', numeric: false, disablePadding: true, label: 'Empresa' },
    { id: 'codeqp', numeric: false, disablePadding: true, label: 'Código Equipamento' },
    { id: 'deseqp', numeric: false, disablePadding: true, label: 'Equipamento' },
    { id: 'codccm', numeric: false, disablePadding: true, label: 'Código Coleta' },
    { id: 'vlrcol', numeric: true, disablePadding: false, label: 'Valor' },
    { id: 'datcol', numeric: false, disablePadding: true, label: 'Data Coleta' },
    { id: 'horcol', numeric: false, disablePadding: true, label: 'Hora Coleta' },
    { id: 'actions', numeric: true, disablePadding: false, label: 'Ações' },
  ];

  const createData = (props:any): BodyCell => {
    const {id, codemp, nomemp, codeqp, deseqp, codccm, vlrcol, datcol, horcol, } = props
    return { id, codemp, nomemp, codeqp, deseqp, codccm, vlrcol, datcol, horcol, ...props };
  }

  const handleOpenDrawer = () => {
    setIsDrawerOpen({open: true, btnTitle: 'Salvar', btnType: 'save'});
  };

  const handleCloseDrawer = () => {
    setSelected([])
    setFields(fieldsInit);
    setIsDrawerOpen({open: false, btnTitle: 'Salvar', btnType: 'save'});
  };

  const handleOpenDialogSearch = (data: DialogSearchData) => {
    setIsDialogSearchOpen(true);
    setDialogDataSearch(data);
  };

  const handleCloseDialogSearch = () => {
    setIsDialogSearchOpen(false);
    setDialogDataSearch(null);
    setSelected([]);
  };

  const handleCloseSnackbar = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }

    setIsSnackbar({open: false, message: '', title: 'info'});
  };

  const handleUpdateField = (data: any) => {
    const update = [...fields];
    update[update.findIndex((field) => field.id === dialogDataSearch?.id)].value = 
      data[dialogDataSearch?.key || ''] === 'Nenhum item' ? null : data
    setFields(update)
    setIsDialogSearchOpen(false);
    setDialogDataSearch(null);
    if(dialogDataSearch?.id === 'dados')
      setCheckPrevCompanyValue(handleCheckPrevValue('dados', update, 'codemp'))
    if(dialogDataSearch?.id === 'equip')
      setCheckPrevEquipamentValue(handleCheckPrevValue('equip', update, 'codeqp'))
  }

  const { isFetching, refetch } = useQuery(['colletionPoint'], async () => {
    // obtem as requisicao rascunho
    const token = localStorage.getItem('token')
    if(token){
      const res = await getDraftMaintenanceCollectionByUser(token, {
        take: rowsPerPage,
        skip: page*rowsPerPage,
      })
      if(res){
        setSelectedData(res.results)
        setCount(res.total)
      }
    }
    return []
  }, {
    refetchOnWindowFocus: false,
  })
  
  useEffect(() => {
    refetch();
  }, [page, refetch]);

  const Alert = (props: AlertProps) => {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

  const handleFormatedDataToDatabase = async (btnType: string) => {
    setIsLoading(true)
    
    let data = {
      codemp: checkPrevCompanyValue.value,
      nomemp: fields.filter((field) => field.id === 'dados')[0].value?.nomemp,
      codeqp: checkPrevEquipamentValue.value,
      deseqp: fields.filter((field) => field.id === 'equip')[0].value?.deseqp,
      codccm: fields.filter((field) => field.id === 'coleta')[0].value?.codccm,
      vlrcol: parseFloat(fields.filter((field) => field.id === 'valorcoleta')[0].value?.vlrcol),
      horcol: fields.filter((field) => field.id === 'datacoleta')[0].value?.datcol.split('T')[1],
      datcol: fields.filter((field) => field.id === 'datacoleta')[0].value?.datcol.split('T')[0],
    }
    
    const useCaseSuccess = {
      save: 'criar apontamento de coleta',
      edit: 'editar apontamento de coleta',
      remove: 'remover apontamento de coleta',
      removeAll: `remover apontament${selected.length > 1 ? 'os': 'o'} de coleta`,
      proccess: `processar apontament${selected.length > 1 ? 'os': 'o'} de coleta`
    } as any

    const token = localStorage.getItem('token')
    let res = {
      statusCode: 400,
    } as any
    
    if(token){
      if(btnType === 'save')
        res = await createMaintenanceCollectionDraft(data, token)
      if(btnType === 'edit' && selected.length > 0)
        res = await updateMaintenanceCollection(selected[0], data, token)
      if(btnType === 'remove' && selected.length > 0)
        res = await deleteMaintenanceCollection(selected[0], token)
      if(btnType === 'removeAll' && selected.length > 0)
          res = await deleteAllMaintenanceCollections(selected, token)
      if(btnType === 'proccess' && selected.length > 0)
        res = await processMaintenanceCollection(selected, token)
      
      setIsLoading(false)
      if(res.statusCode === 200){
        setIsSnackbar({
          open: true,
          message: `Sucesso ao ${useCaseSuccess[btnType]}`,
          title: 'success'
        })
      } else {
        setIsSnackbar({
          open: true,
          message: `Erro ao ${useCaseSuccess[btnType]}`,
          title: 'error'
        })
      }
      refetch()
      setIsDialogFeedbackOpen({
        open: false,
        message: '',
        title: '',
        btnType,
      })
      setIsDrawerOpen({
        open: false,
        btnTitle: '',
        btnType: '',
      })
      setFields(fieldsInit)
      setSelected([])
    } else {
      setIsLoading(false);
      setIsSnackbar({
        open: true,
        message: `Erro ao ${useCaseSuccess[btnType]}`,
        title: 'error'
      })
    }
  } 
  
  const handleCheckFields = () => {
    const requireds = fields.filter((field) => field.required)
    if(requireds.length !== requireds.filter((required) => required.value).length) {
      setIsSnackbar({open:true, message: 'Por favor, adicione os campos obrigatórios!', title: 'error'})
    } else { 
      handleDialogConfirmation(isDrawerOpen.btnType)
    }
  }
  
  const handleDialogConfirmation = (type: string) => {
    const useCaseFeedbackTitle = {
      save: 'Deseja criar um apontamento de coleta',
      edit: 'Deseja editar um apontamento de coleta',
      remove: 'Deseja remover um apontamento de coleta',
      removeAll: 'Deseja remover os apontamentos de coleta selecionadas',
      proccess: `Deseja processar o${selected.length > 1 ? 's apontamentos' : ' apontamento'} de coleta`
    } as any

    setIsDialogFeedbackOpen({
      open: true,
      title: useCaseFeedbackTitle[type],
      message: '',
      btnType: type,
    })
  }

  const handleCloseErro = () => {
    setIsDialogFeedbackOpen({open:false, message: '', title: '', btnType: 'erro'});
    setSelected([])
    setFields(fieldsInit);
  }

  const handleRemoveAll = () => {
    handleDialogConfirmation('removeAll') 
  }

  const handleProcess = () => {
    handleDialogConfirmation('proccess') 
  }

  const handleRemove = (id:any) => {
    handleDialogConfirmation('remove')
  }
  
  const handleErro = (id:any) => {
    setIsDialogFeedbackOpen({
      open: true,
      message: selectedData.filter((data:any) => data.id === id)[0].msgerro,
      title: 'Erro Erp',
      btnType: 'erro'
    })
  }

  const handleEdit = (id:any) => {
    const item = selectedData.filter((data:any) => data.id === id )
    
    setCheckPrevCompanyValue({
      value: item[0].codemp,
      exists: true,
    })

    setCheckPrevEquipamentValue({
      value: item[0].codeqp,
      exists: true,
    })
    
    setFields(mapperToMaintenanceCollection(item[0]))
    setIsDrawerOpen({open: true, btnTitle: 'Editar', btnType: 'edit'});
  }

  const handleCheckError = () => {
    const itemSelected = selectedData.filter((data:any) => data.id === selected[0])
    if(itemSelected){
      const erro =  Object.entries(itemSelected[0]).find(([key, val]) => key.includes('erro'))
      if(erro && erro[1] !== null)
        return true
      else
        return false
    }
    return false
  }

  return (
    <div className={classes.root}>
      <CollectionPointHeader
        onClick={handleOpenDrawer}
      />
      <div className={classes.tableSection}>
        <Container className={classes.tableSectionContainer}>
          <EnhancedTable 
            title='Apontamentos'
            rowsPerPageOptions={[]}
            isClickable={true}
            data={selectedData?.map((data:any) => createData(data) )}
            count={count}
            orderBy={orderBy}
            setOrderBy={setOrderBy}
            headCells={headCells}
            isLoading={isFetching}
            selected={selected}
            setSelected={setSelected}
            page={page}
            setPage={setPage}
            rowsPerPage={rowsPerPage}
            setRowsPerPage={setRowsPerPage}
             buttonsSelected={[
              selected.length === 1 && 
              <Tooltip 
                title="Editar"
                onClick={() => handleEdit(`${selected[0]}`)}
                key='edit'
              >
                <IconButton aria-label="edit">
                  <EditIcon style={{color: customtheme.white}}/>
                </IconButton>
              </Tooltip>,
            (selected.length === 1 && handleCheckError()) && 
              <Tooltip
                title="Erro"
                onClick={() => handleErro(`${selected[0]}`)}
                key='erro'
              >
              <IconButton aria-label="erro">
                <ErrorIcon style={{color: customtheme.white}}/>
              </IconButton>
            </Tooltip>,
              <Tooltip title="Deletar" onClick={handleRemoveAll} key='deleteall'>
                <IconButton aria-label="delete">
                  <DeleteSweepIcon style={{color: customtheme.white}}/>
                </IconButton>
              </Tooltip>,
              <Tooltip title="Processar" onClick={handleProcess} key='process'>
                <IconButton aria-label="processar">
                  <SendIcon style={{color: customtheme.white}}/>
                </IconButton>
              </Tooltip>,
            ]}
            buttonsActions={['edit', 'erro', 'remove']}
            handleEdit={handleEdit}
            handleErro={handleErro}
            handleRemove={handleRemove}
          />
        </Container>
      </div>
      <CollectionPointDrawer
        checkPrevCompanyValue={checkPrevCompanyValue}
        checkPrevEquipamentValue={checkPrevEquipamentValue}
        fields={fields}
        handleCheckFields={handleCheckFields}
        handleCloseDrawer={handleCloseDrawer}
        handleCloseSnackbar={handleCloseSnackbar}
        handleOpenDialogSearch={handleOpenDialogSearch}
        isDrawerOpen={isDrawerOpen}
        setFields={setFields}
      />
      <DialogSearch
        title={dialogDataSearch?.title || ''}
        id={dialogDataSearch?.id || ''}
        keyItem={dialogDataSearch?.key || ''}
        keySubItem={dialogDataSearch?.keySub || ''}
        isDialogOpen={isDialogSearchOpen}
        isPrevSearch={dialogDataSearch?.isPrevSearch || false}
        prevSearch={dialogDataSearch?.prevSearch || []}
        prevDataSearch={dialogDataSearch?.prevDataSearch}
        handleCloseDialog={handleCloseDialogSearch}
        handleUpdateField={(data:any) => { handleUpdateField(data) }}
      />
      <CollectionPointDialog
        handleCloseErro={handleCloseErro}
        handleFormatedDataToDatabase={handleFormatedDataToDatabase}
        isDialogFeedbackOpen={isDialogFeedbackOpen}
        isLoading={isLoading}
      />
      <Snackbar open={isSnackbar.open} autoHideDuration={3000} onClose={handleCloseSnackbar}>
        <Alert onClose={handleCloseSnackbar} severity={isSnackbar.title as any}>
          {isSnackbar.message}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default ColletionPoint;